<template>
	<v-dialog v-model="showDialog" persistent :max-width="options.width">
		<v-card>
			<v-toolbar dark :color="options.color" dense flat>
				<v-toolbar-title class="white--text" style="margin: 0 -8px;">{{ title }}</v-toolbar-title>
			</v-toolbar>
			<v-card-text v-show="!!message" class="py-4" v-html="message" />
			<v-card-actions class="px-3 pb-3">
				<v-btn color="danger" class="white--text" @click.native="cancel">NÃO</v-btn>
				<v-spacer />
				<v-btn color="success" @click.native="agree">SIM</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		data() {
			return {
				showDialog: false,
				resolve: null,
				reject: null,
				message: null,
				title: null,
				options: {
					color: 'primary',
					width: 500
				}
			};
		},

		methods: {
			open(message, title = 'Confirmação', options) {
				this.showDialog = true;
				this.message = message;
				this.title = title;
				this.options = Object.assign(this.options, options);

				return new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;
				});
			},

			agree() {
				this.resolve(true);
				this.showDialog = false;
			},

			cancel() {
				this.resolve(false);
				this.showDialog = false;
			}
		}
	};
</script>